import React, { useState } from 'react';
import styled from 'styled-components';
import Button from '../common/Button';

const FilterSection = styled.section`
  background-color: ${props => props.theme.colors.lightColor};
  padding: 30px 0;
`;

const FilterHeader = styled.h3`
  margin-bottom: 20px;
  text-align: center;
  color: ${props => props.theme.colors.secondaryColor};
`;

const FilterOptions = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: stretch;
  }
`;

const FilterGroup = styled.div`
  display: flex;
  align-items: center;
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const FilterLabel = styled.label`
  margin-right: 10px;
  font-weight: 600;
  color: ${props => props.theme.colors.secondaryColor};
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    margin-bottom: 5px;
  }
`;

const FilterSelect = styled.select`
  padding: 10px;
  border: 1px solid ${props => props.theme.colors.grey[300]};
  border-radius: 4px;
  background-color: white;
  color: ${props => props.theme.colors.grey[700]};
  font-family: ${props => props.theme.fonts.primary};
  
  &:focus {
    outline: none;
    border-color: ${props => props.theme.colors.primaryColor};
  }
  
  @media (max-width: ${props => props.theme.breakpoints.sm}) {
    width: 100%;
  }
`;

const CourseFilter = () => {
  const [filters, setFilters] = useState({
    category: 'all',
    duration: 'all',
    mode: 'all'
  });
  
  const handleFilterChange = (e) => {
    const { name, value } = e.target;
    setFilters({
      ...filters,
      [name]: value
    });
  };
  
  const handleApplyFilters = () => {
    // This would typically dispatch an action or call a method
    // to filter courses based on the selected criteria
    console.log('Applying filters:', filters);
    
    // Here you would trigger filtering of courses shown on the page
  };
  
  return (
    <FilterSection>
      <div className="container">
        <FilterHeader>Find Your Course</FilterHeader>
        <FilterOptions>
          <FilterGroup>
            <FilterLabel htmlFor="category">Category:</FilterLabel>
            <FilterSelect 
              id="category" 
              name="category" 
              value={filters.category}
              onChange={handleFilterChange}
            >
              <option value="all">All Categories</option>
              <option value="structural">Structural Engineering</option>
              <option value="civil">Civil Engineering</option>
              <option value="exam">Exam Preparation</option>
              <option value="software">Software Training</option>
            </FilterSelect>
          </FilterGroup>
          
          <FilterGroup>
            <FilterLabel htmlFor="duration">Duration:</FilterLabel>
            <FilterSelect 
              id="duration" 
              name="duration" 
              value={filters.duration}
              onChange={handleFilterChange}
            >
              <option value="all">All Durations</option>
              <option value="short">Short-term (1-2 Months)</option>
              <option value="medium">Medium-term (3-6 Months)</option>
              <option value="long">Long-term (6+ Months)</option>
            </FilterSelect>
          </FilterGroup>
          
          <FilterGroup>
            <FilterLabel htmlFor="mode">Mode:</FilterLabel>
            <FilterSelect 
              id="mode" 
              name="mode" 
              value={filters.mode}
              onChange={handleFilterChange}
            >
              <option value="all">All Modes</option>
              <option value="online">Online</option>
              <option value="offline">Offline</option>
              <option value="hybrid">Hybrid</option>
            </FilterSelect>
          </FilterGroup>
          
          <Button 
            variant="secondary" 
            onClick={handleApplyFilters}
          >
            Apply Filters
          </Button>
        </FilterOptions>
      </div>
    </FilterSection>
  );
};

export default CourseFilter;
